export const setMetaTag = (selector, attrName, attrValue, content) => {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attrName, attrValue);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export const removeMetaTag = (selector) => {
  const tag = document.querySelector(selector);
  if (tag) tag.remove();
};
